import styled from 'styled-components';

export const Container = styled.div`
  height: 250px;
  width: 100%;
  position: relative;
`;

export const Items = styled.div`
  height: 100%;
  width: 100%;
  overflow: hidden;
  display: flex;
  border-radius: 20px;

  @media (max-width: 800px) {
    border-radius: 0;
  }
`;

export const Image = styled.img`
  flex: none;
  height: 100%;
  width: 100%;
  object-fit: cover;
  transition: 0.5s ease-in-out;
`;

export const IconWrapper = styled.button`
  position: absolute;
  top: 0;
  height: 100%;
  width: 80px;
  background: transparent;
  border: 0;
  outline: 0;
  cursor: pointer;
`;
